import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Offcanvas } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { post } from "../../../services/api";
import { getDropDown } from "../../../store/actions/DropdownActions";

const AddLov = forwardRef((props, ref) => {

  const [addLov, setAddLov] = useState(false);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    value:"",
    type:"",
    attribute1:"",
    attribute2:"",
    attribute3:"",
    attribute4:""
                   
  });
  

  
  const resetForm = () => {
    setFormData({
      value:"",
      type:"",
      attribute1:"",
      attribute2:"",
      attribute3:"",
      attribute4:""
    });
  };

  const [errors, setErrors] = useState({});
  useImperativeHandle(ref, () => ({
    showAddLovModal() {
      setAddLov(true);
    },
  }));

  const validate = () => {

    const newErrors = {};

    const requiredFields = [
      "value",
      "type"
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]?.trim()) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
      }
    });

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all the required fields.");
    }
    return Object.keys(newErrors).length === 0;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      await post('/api/lov', formData, props.token);
      toast.success("Lov data saved");
      await dispatch(getDropDown(props.token));
      setAddLov(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  return (
    <Offcanvas
      show={addLov}
      onHide={() => setAddLov(false)}
      className="offcanvas-end customeoff"
      placement="end"
    >
      <div className="offcanvas-header">
        <h5 className="modal-title">{props.Title}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            resetForm();
            setAddLov(false);
          }}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
          {[
                  {
                    label: "Drowdown Type",
                    field: "type",
                    required: true,
                  },
                  {
                    label: "Value",
                    field: "value",
                    required: true,
                  },

                  {
                    label: "Additional Attribute 1",
                    field: "attribute1",
                  },
                  {
                    label: "Additional Attribute 1",
                    field: "attribute2",
                  },
                  {
                    label: "Additional Attribute 1",
                    field: "attribute3",
                  },
                  {
                    label: "Additional Attribute 1",
                    field: "attribute4",
                  },
                  
                ].map(
                  ({
                    label,
                    field,
                    type = "text",
                    required = false,
                    disabled = false,
                    options = [],
                  }) => (
                    <div className="col-xl-6 mb-3" key={field}>
                      
                        <>
                          <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                          <input
                            type={type}
                            className="form-control"
                            disabled={disabled}
                            value={formData[field]}
                            onChange={(e) =>
                              handleInputChange(field, e.target.value)
                            }
                          />
                        </>
                      {errors[field] && (
                        <small className="text-danger">{errors[field]}</small>
                      )}
                    </div>
                  )
                )}
          </div>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
          <Link
            to={"#"}
            onClick={() => {
              resetForm();
              setAddLov(false);
            }}
            className="btn btn-danger ms-2"
          >
            Cancel
          </Link>
        </form>
      </div>
    </Offcanvas>
  );
});

export default AddLov;
